import { SelectOption } from '@/lib/Selects/Select/types';
import { PerformanceAudienceFilterOption } from '@/services/endpoints/performanceAudience';
import { TFunction } from 'i18next';

export const DATE_RANGE_FILTER_IDS = new Set([
  'today',
  'yesterday',
  'last_7_days',
  'last_14_days',
  'last_30_days',
  'current_month',
  'last_month',
  'current_quarter',
  'custom',
]);

export const DATE_RANGE_CUSTOM_ID = 'custom';

export const getFilterOptionDisplayLabel = (
  option: PerformanceAudienceFilterOption,
  t: TFunction<'performanceAudience'>,
  customRangeLabel?: string
): string => {
  if (option.id === DATE_RANGE_CUSTOM_ID && customRangeLabel) {
    return customRangeLabel;
  }

  if (DATE_RANGE_FILTER_IDS.has(option.id)) {
    return t(`filters.${option.id}`);
  }

  return option.menuLabel ?? [option.value, option.suffix].filter(Boolean).join(' ');
};

export const toFilterMenuOptions = (
  items: PerformanceAudienceFilterOption[],
  t: TFunction<'performanceAudience'>
): SelectOption[] =>
  items.map((item) => ({
    id: item.id,
    label: getFilterOptionDisplayLabel(item, t),
    disabled: false,
  }));

export const findFilterOption = (items: PerformanceAudienceFilterOption[], id: string) =>
  items.find((item) => item.id === id) ?? null;
